/**
 * Member Store
 * FSD: features/auth/stores
 *
 * 사용자 정보 상태 관리
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { devtools } from "zustand/middleware";
import { ZUSTAND_PERSIST_KEY } from "@/shared/lib/constants";
import { User } from "@/entities/auth";

interface MemberStore {
  user: User | null;
  setUser: (user: User | null) => void;
  clearUser: () => void;
}

export const useMemberStore = create<MemberStore>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        setUser: (user) => set({ user }),
        clearUser: () => set({ user: null }),
      }),
      {
        name: ZUSTAND_PERSIST_KEY,
      }
    ),
    { name: "MemberStore" }
  )
);
